<div #modalRef class="modal fade payment-block-modal" tabindex="-1" aria-hidden="true" aria-labelledby="paymentBlockModalTitle">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content payment-block-card">

      <div class="modal-header">
        <h5 class="modal-title" id="paymentBlockModalTitle"
            [class.success]="outcome === 'success'" [class.failure]="outcome === 'failure'">
          {{ outcome === 'success' ? 'Payment Successful' : outcome === 'failure' ? 'Payment Unsuccessful' : 'Payment Processing' }}
        </h5>
        <button
          type="button"
          class="btn-close"
          (click)="onCloseClick()"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body text-center">
        <div class="payment-block-icon" [class.success]="outcome === 'success'" [class.failure]="outcome === 'failure'">
          <i class="fa-solid"
             [class.fa-arrows-rotate]="outcome === 'processing'" [class.fa-spin]="outcome === 'processing'"
             [class.fa-circle-check]="outcome === 'success'"
             [class.fa-circle-xmark]="outcome === 'failure'"></i>
        </div>

        <p *ngIf="outcome === 'processing'">
          Your payment is currently being processed.
          Please do not close or refresh this page, or attempt another payment.
        </p>
        <p *ngIf="outcome !== 'processing'">{{ outcomeMessage }}</p>

        <div class="payment-block-timer" *ngIf="outcome === 'processing'">
          <i class="fa-regular fa-clock"></i>
          <span class="payment-block-timer-label">Time remaining :</span>
          <span class="payment-block-timer-value">{{ timeLabel }}</span>
        </div>

        <p *ngIf="outcome === 'processing'">
           This page will update automatically once your payment is confirmed, and your receipt will be available for download.
        </p>
      </div>

      <div class="modal-footer justify-content-center">
        <button *ngIf="outcome === 'processing'" type="button" class="btn btn-primary" (click)="onGoHome()">
          <i class="fa-solid fa-house me-2"></i>Go to Home
        </button>
        <button *ngIf="outcome !== 'processing'" type="button" class="btn btn-primary" (click)="onAcknowledge()">
          Okay
        </button>
      </div>
    </div>
  </div>
</div>
